import React from 'react';

const GitHubIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const CodePenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width=".42in" height=".42in" viewBox="0 0 30.22 30.22" fill="currentColor" aria-hidden="true">
    <path d="M29.64,9.43L15.83.22c-.44-.29-1.01-.29-1.45,0L.57,9.43c-.35.24-.57.64-.57,1.07v9.21c0,.43.22.83.57,1.08l13.81,9.21c.44.29,1.01.29,1.45,0l13.81-9.21c.36-.24.57-.65.57-1.08v-9.21c0-.43-.22-.83-.57-1.08h0ZM16.41,3.73l10.17,6.77-4.54,3.03-5.63-3.76V3.73ZM13.81,3.73v6.05l-5.63,3.76-4.53-3.04L13.81,3.73ZM2.6,12.93l3.25,2.18-3.25,2.17v-4.35ZM13.81,26.49l-10.17-6.78,4.54-3.03,5.63,3.76v6.05ZM15.11,18.18l-4.59-3.07,4.59-3.07,4.59,3.07-4.59,3.07ZM16.41,26.49v-6.05l5.63-3.76,4.54,3.03-10.17,6.78ZM27.62,17.28l-3.25-2.18,3.25-2.18v4.35Z"/>
  </svg>
);

const socialLinks = [
  { href: 'https://github.com/shelaine', Icon: GitHubIcon, label: 'GitHub' },
  { href: 'https://www.linkedin.com/in/shelaine/', Icon: LinkedInIcon, label: 'LinkedIn' },
  { href: 'https://codepen.io/shelaine/', Icon: CodePenIcon, label: 'CodePen' },
];

function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar__logo">
        <img src="/logo.svg" alt="Shelaine Roustio Logo" />
      </div>

      <div className="sidebar__identity">
        <h1 className="sidebar__name">Shelaine Roustio</h1>
        <span className="sidebar__title">Web Developer</span>
      </div>

      <p className="sidebar__bio">
        Hi, I'm Shelaine — a web developer with an eye for design and a passion for building beautiful, performance-driven, and maintainable websites. I specialize in WordPress development: custom themes, blocks, and integrations using React and modern build systems.
      </p>

    <nav className="sidebar__social" aria-label="Social links">
    {socialLinks.map(({ href, Icon, label }) => (
        <a 
        key={label}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="sidebar__social-link"
        aria-label={label}
        >
        <Icon />
        </a>
    ))}
    </nav>

    </aside>
  );
}

export default Sidebar;